import './index.css';

export default {
  name: 'Arain',
  render() {
    return (
      <div class="a-rain">
        <div class="a-body" />
      </div>
    );
  }
}